import React, { useState, useRef, useEffect } from 'react';
import { Switch, Button, Col, Drawer, Form, Input, Row, Select, Space, message, Typography } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { getList as getAllConcepts } from '../../../../apis/ConceptoApi';
import { insert, update, getById, getLeaveTypesOdoo } from '../../../../apis/TipoIncapacidadApi';

const { Title } = Typography;
const { Option } = Select;

const App = ({ title, id, open, finish }) => {
    const [form] = Form.useForm();
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [concepts, setConcepts] = useState([]);
    const [leaveTypesOdoo, setLeaveTypesOdoo] = useState([]);
    
    // Opciones para los selects
    const ramasSeguro = [
        { value: 1, label: 'Riesgo Trabajo' },
        { value: 2, label: 'Enfermedad General' },
        { value: 3, label: 'Maternidad' }
    ];

    const tiposRiesgo = [
        { value: 0, label: 'Ninguno' },
        { value: 1, label: 'Accidente Trabajo' },
        { value: 2, label: 'Accidente Trayecto' },
        { value: 3, label: 'Enfermedad Profesional' }
    ];

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue();
        const payload = {
            tipo: fields.clave,
            descripcion: fields.descripcion,
            rama_seguro: fields.rama_seguro,
            tipo_riesgo: fields.tipo_riesgo,
            tipo_ausencia: fields.tipo_ausencia.toString(),
            activo: fields.activo
        };

        let success = false;
        
        if (ID > 0) {
            // Update
            const response = await update({ id: ID, ...payload });
            success = response.ok;
            if (response.ok) {
                message.success('Se actualizó correctamente el tipo de incapacidad!');
            }
        } else {
            // Create
            const response = await insert(payload);
            success = response.ok;
            if (response.ok) {
                setID(response.payload);
                message.success('Se guardó correctamente el tipo de incapacidad!');
            }
        }

        if (success) {
            setModified(true);
            onClose(true);
        }
    };

    const onClose = (reload) => {
        finish(reload ?? modified);
        setInitialValues(null);
    };

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getConcepts();
                await getOdooLeaveTypes();
                if (ID > 0) {
                    await refreshData();
                } else {
                    setInitialValues({
                        activo: true,
                        rama_seguro: 1, // Valor por defecto
                        tipo_riesgo: 0  // Valor por defecto
                    });
                }
                setModified(false);
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const refreshData = async () => {
        const response = await getById(ID);
        if (response.ok) {
            let tipoIncapacidad = response.payload;
            setInitialValues({
                clave: tipoIncapacidad.tipo,
                descripcion: tipoIncapacidad.descripcion,
                rama_seguro: tipoIncapacidad.rama_seguro,
                tipo_riesgo: tipoIncapacidad.tipo_riesgo,
                tipo_ausencia: parseInt(tipoIncapacidad.tipo_ausencia),
                activo: tipoIncapacidad.activo
            });
        }
    };

    const getConcepts = async () => {
        const response = await getAllConcepts();
        if (response.ok) {
            setConcepts(response.payload);
        }
    };

    const getOdooLeaveTypes = async () => {
        const response = await getLeaveTypesOdoo();
        if (response.ok) {
            setLeaveTypesOdoo(response.payload);
        }
    };


    return (
        <Drawer
            title={title}
            width={720}
            placement="right"
            onClose={onClose}
            open={open}
            closable={true}
            extra={
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">Guardar</Button>
                </Space>
            }
        >
            {initialValues && (
                <Form
                    layout="vertical"
                    form={form}
                    autoComplete="off"
                    initialValues={initialValues}
                    onFinish={handleOk}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="clave"
                                label="Tipo (Clave Única)"
                                rules={[{ required: true, message: 'Por favor ingresa la clave única' }]}
                            >
                                <Input placeholder="Ingresa la clave única" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="descripcion"
                                label="Descripción"
                                rules={[{ required: true, message: 'Por favor ingresa la descripción' }]}
                            >
                                <Input placeholder="Ingresa la descripción" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="rama_seguro"
                                label="Rama Seguro"
                                rules={[{ required: true, message: 'Por favor selecciona la rama de seguro' }]}
                            >
                                <Select placeholder="Selecciona rama de seguro">
                                    {ramasSeguro.map((rama) => (
                                        <Option key={rama.value} value={rama.value}>
                                            {rama.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="tipo_riesgo"
                                label="Tipo Riesgo"
                                rules={[{ required: true, message: 'Por favor selecciona el tipo de riesgo' }]}
                            >
                                <Select placeholder="Selecciona tipo de riesgo">
                                    {tiposRiesgo.map((tipo) => (
                                        <Option key={tipo.value} value={tipo.value}>
                                            {tipo.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="tipo_ausencia"
                                label="Tipo de Ausencia"
                                rules={[{ required: true, message: 'Por favor selecciona el tipo de ausencia' }]}
                            >
                                <Select
                                    placeholder="Selecciona tipo de ausencia"
                                    showSearch
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {leaveTypesOdoo.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="activo"
                                label="Activo"
                                valuePropName="checked"
                            >
                                <Switch
                                    checkedChildren={<CheckOutlined />}
                                    unCheckedChildren={<CloseOutlined />}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
        </Drawer>
    );
};

export default App;